import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Signature from "./components/Signature";
import BeforeVisit from "./components/BeforeVisit";
import Schedule from "./components/Schedule";
import Location from "./components/Location";
import Closing from "./components/Closing";
import Footer from "./components/Footer";
import WhatsAppFloat from "./components/WhatsAppFloat";
import WaveDivider from "./components/WaveDivider";

export default function Home() {
  const { i18n } = useTranslation();

  useEffect(() => {
    document.documentElement.lang = i18n.language.startsWith("en") ? "en" : "es";
  }, [i18n.language]);

  return (
    <div className="min-h-screen w-full bg-background-50">
      <Header />
      <main>
        <Hero />
        <About />
        <WaveDivider />
        <Signature />
        <WaveDivider />
        <BeforeVisit />
        <WaveDivider />
        <Schedule />
        <WaveDivider />
        <Location />
        <WaveDivider />
        <Closing />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}